import React from 'react';
import { X, CheckCircle2 } from 'lucide-react';
export function InvisibleDecisions() {
  return <section className="w-full py-24 px-6 md:px-12 lg:px-24 bg-black" data-id="element-805">
      <div className="max-w-7xl mx-auto" data-id="element-806">
        <div className="text-center mb-16" data-id="element-807">
          <h2 className="text-4xl md:text-5xl font-bold font-['Syne'] text-white mb-4" data-id="element-808">
            See It In Action: Client Communications
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-809">
          {/* Without Context Engineering */}
          <div className="bg-white/5 border border-white/10 rounded-2xl p-8 md:p-10" data-id="element-810">
            <div className="flex items-center gap-3 mb-8" data-id="element-811">
              <div className="w-10 h-10 rounded-full bg-red-500/20 flex items-center justify-center" data-id="element-812">
                <X className="w-6 h-6 text-red-400" data-id="element-813" />
              </div>
              <h3 className="text-2xl font-bold font-['Syne'] text-white" data-id="element-814">
                Without Context Engineering
              </h3>
            </div>

            <div className="mb-8" data-id="element-815">
              <p className="text-lg font-semibold text-white mb-4" data-id="element-816">
                AI Guesses:
              </p>
              <ul className="space-y-3" data-id="element-817">
                <GuessItem text="Who is the audience?" data-id="element-818" />
                <GuessItem text="What tone is appropriate?" data-id="element-819" />
                <GuessItem text="Which rules apply?" data-id="element-820" />
                <GuessItem text="What can I say?" data-id="element-821" />
                <GuessItem text="How formal should I be?" data-id="element-822" />
              </ul>
            </div>

            <div className="pt-6 border-t border-white/10" data-id="element-823">
              <p className="text-sm font-bold text-red-400 uppercase tracking-wide mb-2" data-id="element-824">
                Result:
              </p>
              <p className="text-white/80 text-lg" data-id="element-825">
                Generic, risky, multiple review cycles
              </p>
            </div>
          </div>

          {/* With Context Engineering */}
          <div className="bg-white/5 border border-green-500/30 rounded-2xl p-8 md:p-10 relative overflow-hidden" data-id="element-826">
            <div className="absolute top-0 right-0 w-32 h-32 bg-green-500/10 rounded-bl-full" data-id="element-827"></div>

            <div className="flex items-center gap-3 mb-8 relative z-10" data-id="element-828">
              <div className="w-10 h-10 rounded-full bg-green-500/20 flex items-center justify-center" data-id="element-829">
                <CheckCircle2 className="w-6 h-6 text-green-500" data-id="element-830" />
              </div>
              <h3 className="text-2xl font-bold font-['Syne'] text-white" data-id="element-831">
                With Context Engineering
              </h3>
            </div>

            <div className="mb-8 relative z-10" data-id="element-832">
              <p className="text-lg font-semibold text-white mb-4" data-id="element-833">AI Knows:</p>
              <ul className="space-y-3" data-id="element-834">
                <KnowsItem text="Client relationship type and history" data-id="element-835" />
                <KnowsItem text="Regulatory compliance requirements" data-id="element-836" />
                <KnowsItem text="Approved messaging frameworks" data-id="element-837" />
                <KnowsItem text="Prohibited claims and statements" data-id="element-838" />
                <KnowsItem text="Brand voice and tone standards" data-id="element-839" />
              </ul>
            </div>

            <div className="pt-6 border-t border-white/10 relative z-10" data-id="element-840">
              <p className="text-sm font-bold text-green-500 uppercase tracking-wide mb-2" data-id="element-841">
                Result:
              </p>
              <p className="text-white text-lg font-medium" data-id="element-842">
                Client-ready, minimal reviews
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
function GuessItem({
  text
}: {
  text: string;
}) {
  return <li className="flex items-start gap-3" data-id="element-843">
      <X className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-844" />
      <span className="text-white/70 leading-relaxed" data-id="element-845">{text}</span>
    </li>;
}
function KnowsItem({
  text
}: {
  text: string;
}) {
  return <li className="flex items-start gap-3" data-id="element-846">
      <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-847" />
      <span className="text-white/90 leading-relaxed" data-id="element-848">{text}</span>
    </li>;
}